import React from "react";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  Select,
  Link,
  SearchableList,
  MultiSelectDropdown,
} from "../../../components";
import { getTwoDecimalPlaces } from "../../../utils";
const columns = [
  {
    label: "Type of fees",
    className: "table-width-40",
    columnName: "typeOfFees",
  },
  {
    label: "",
    className: "table-width-30",
    columnName: "fees",
  },
  {
    label: "Amount",
    className: "table-width-30",
    columnName: "amount",
  },
];
const data = [
  {
    typeOfFees: "Check",
    fees: 340123,
    amount: 102123,
  },
  {
    typeOfFees: "ACH",
    fees: 340123,
    amount: 102123,
  },
  {
    typeOfFees: "Wire",
    fees: 340123,
    amount: 102123,
  },
  {
    typeOfFees: "Final distribution",
    fees: 340123,
    amount: 102123,
  },
];
const data2 = [
  {
    typeOfFees: "Check",
    fees: 340123,
    amount: 102123,
  },
  {
    typeOfFees: "ACH",
    fees: 340123,
    amount: 102123,
  },
  {
    typeOfFees: "Wire",
    fees: 340123,
    amount: 102123,
  },
];
const data3 = [
  {
    typeOfFees: "Stale check fee",
    fees: 340123,
    amount: 102123,
  },
  {
    typeOfFees: "Check reissue fee",
    fees: 340123,
    amount: 102123,
  },
  {
    typeOfFees: "Overnight mail fee",
    fees: 340123,
    amount: 102123,
  },
  {
    typeOfFees: "Check copy fee",
    fees: 340123,
    amount: 102123,
  },
  {
    typeOfFees: "Total other fees",
    fees: 340123,
    amount: 102123,
  },
];
const totalDistributionFees = {
  typeOfFees: "Total distribution fees, including RMDs",
  fees: 340123,
  amount: 102123,
};
const rolloverTotal = {
  typeOfFees: "Total Rollover Fees",
  fees: 340123,
  amount: 102123,
};
const otherFeesTotal = {
  typeOfFees: "Total other fees",
  fees: 340123,
  amount: 102123,
};
const finalParticulars = [
  {
    typeOfFees: "Loan set up fees",
    fees: 340123,
    amount: 102123,
  },
  {
    typeOfFees: "Total fees",
    fees: 340123,
    amount: 102123,
  },
];
export const ParticipantFeeStatement = (props) => {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          {columns.map((e, i) => (
            <Table.Th className={e.className}>{e.label}</Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        <Table.Tr>
          <Table.Th className="table-sub-header">
            Distribution fees, including RMDs
          </Table.Th>
        </Table.Tr>
        {data.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "typeOfFees" ? (
                <Table.Td className="table-width-25">
                  {e[f.columnName]}
                </Table.Td>
              ) : (
                <Table.Td className="table-width-25">
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        <Table.Tr>
          {columns.map((f, j) =>
            f.columnName === "typeOfFees" ? (
              <Table.Td className="table-width-25 table-total-value">
                {totalDistributionFees[f.columnName]}
              </Table.Td>
            ) : (
              <Table.Td className="table-width-25 table-total-value">
                ${getTwoDecimalPlaces(totalDistributionFees[f.columnName])}
              </Table.Td>
            )
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Th className="table-sub-header">Rollover Fees</Table.Th>
        </Table.Tr>
        {data2.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "typeOfFees" ? (
                <Table.Td className="table-width-25">
                  {e[f.columnName]}
                </Table.Td>
              ) : (
                <Table.Td className="table-width-25">
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        <Table.Tr>
          {columns.map((f, j) =>
            f.columnName === "typeOfFees" ? (
              <Table.Td className="table-width-25 table-total-value">
                {rolloverTotal[f.columnName]}
              </Table.Td>
            ) : (
              <Table.Td className="table-width-25 table-total-value">
                ${getTwoDecimalPlaces(rolloverTotal[f.columnName])}
              </Table.Td>
            )
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Th className="table-sub-header">Other fees</Table.Th>
        </Table.Tr>
        {data3.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "typeOfFees" ? (
                <Table.Td className="table-width-25">
                  {e[f.columnName]}
                </Table.Td>
              ) : (
                <Table.Td className="table-width-25">
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        <Table.Tr>
          {columns.map((f, j) =>
            f.columnName === "typeOfFees" ? (
              <Table.Td className="table-width-25 table-total-value">
                {otherFeesTotal[f.columnName]}
              </Table.Td>
            ) : (
              <Table.Td className="table-width-25 table-total-value">
                ${getTwoDecimalPlaces(otherFeesTotal[f.columnName])}
              </Table.Td>
            )
          )}
        </Table.Tr>
        {finalParticulars.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "typeOfFees" ? (
                <Table.Td className="table-width-25 table-total-value">
                  {e[f.columnName]}
                </Table.Td>
              ) : (
                <Table.Td className="table-width-25 table-total-value">
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};
